export const isDashboardBlocked = 1948
export const isReviewInBulkEnabled = 2113
export const isOfficialMagentoRestApiEnabled = 628
export const isFlagForReviewEnabled = 2872

// The `configuration-chat-enabled` Flagr flag. On/off and per-ecommerce targeting
// live in Flagr (TECH-4431); the launcher renders only where it resolves on.
export const isConfigurationChatEnabled = 3433

// Group-level return conditions, refund configuration and return reasons, one flag each.
export const isReturnConditionsV2Enabled = 4456
export const isRefundConfigurationV2Enabled = 4457
export const isReturnReasonsV2Enabled = 4458

export const isNangoCredentialsEnabled = 4027
// `dashboard-integrations-staff-view`: the REVER staff it lists see Integrations on every portal.
export const isIntegrationsStaffViewEnabled = 4588
